import { useSidebar } from '@buffer-mono/popcorn'

import styles from './SidebarEdgeTrigger.module.css'

import type { JSX } from 'react'

export function SidebarEdgeTrigger(): JSX.Element {
  const { state, toggleSidebar } = useSidebar()

  const label = state === 'expanded' ? 'Close' : 'Open'

  // Not focusable via tab - SidebarTrigger in footer provides keyboard access
  return (
    <button
      type="button"
      className={styles.edgeTrigger}
      onClick={toggleSidebar}
      aria-label={`${label} sidebar`}
      aria-expanded={state === 'expanded'}
      tabIndex={-1}
    />
  )
}
